var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advanced-setting" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.advSet, "label-width": "170px" } },
        [
          _c("h3", [_vm._v("支付设置")]),
          _vm.advSet && _vm.advSet.pay_setting
            ? [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "微信支付：",
                              prop: "pay_setting.open_wxpay",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.advSet.pay_setting.open_wxpay,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.pay_setting,
                                      "open_wxpay",
                                      $$v
                                    )
                                  },
                                  expression: "advSet.pay_setting.open_wxpay",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.advSet.pay_setting.open_wxpay == 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "纯微信支付：",
                                  prop: "pay_setting.only_wxpay",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.advSet.pay_setting.only_wxpay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advSet.pay_setting,
                                          "only_wxpay",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "advSet.pay_setting.only_wxpay",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("开启"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("关闭"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.advSet.pay_setting.open_wxpay == 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "电影次卡补差价：",
                                  prop: "pay_setting.open_movie_price_diff",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.advSet.pay_setting
                                          .open_movie_price_diff,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advSet.pay_setting,
                                          "open_movie_price_diff",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n\t\t\t\t\t\t\t\tadvSet.pay_setting.open_movie_price_diff\n\t\t\t\t\t\t\t",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("开启"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("关闭"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.advSet.pay_setting.open_wxpay == 1
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "点卡补差价：",
                                  prop: "pay_setting.open_weixin_diff_amount",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.advSet.pay_setting
                                          .open_weixin_diff_amount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advSet.pay_setting,
                                          "open_weixin_diff_amount",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n\t\t\t\t\t\t\t\tadvSet.pay_setting.open_weixin_diff_amount\n\t\t\t\t\t\t\t",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("开启"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("关闭"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "是否展示支付说明：",
                              prop: "pay_setting.show_pay_instructions",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.pay_setting
                                      .show_pay_instructions,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.pay_setting,
                                      "show_pay_instructions",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\t\tadvSet.pay_setting.show_pay_instructions\n\t\t\t\t\t\t\t",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "shop_selling_unit" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "用于设置在C端商品售价的显示单位，例如：电影票票价为42.00点；为空时，不展示单位",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" c端商品售价单位： "),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.advSet.pay_setting
                                          .is_shop_selling_unit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advSet.pay_setting,
                                          "is_shop_selling_unit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n\t\t\t\t\t\t\t\t\tadvSet.pay_setting.is_shop_selling_unit\n\t\t\t\t\t\t\t\t",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("使用默认售价单位"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("自定义售价单位"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.advSet.pay_setting.is_shop_selling_unit ===
                                "1"
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "150px",
                                        "margin-left": "10px",
                                      },
                                      attrs: { placeholder: "请输入售价单位" },
                                      model: {
                                        value:
                                          _vm.advSet.pay_setting
                                            .shop_selling_unit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advSet.pay_setting,
                                            "shop_selling_unit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "\n\t\t\t\t\t\t\t\t\tadvSet.pay_setting.shop_selling_unit\n\t\t\t\t\t\t\t\t",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "开通支付密码：",
                              prop: "pay_setting.open_pay_pwd",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.advSet.pay_setting.open_pay_pwd,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.pay_setting,
                                      "open_pay_pwd",
                                      $$v
                                    )
                                  },
                                  expression: "advSet.pay_setting.open_pay_pwd",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "pay_setting.open_double_pay" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "开启后，最多支持4张卡叠加支付（4张卡 相当1张卡）；关闭后，只可使用一张。",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 开通次卡叠加支付： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.advSet.pay_setting.open_double_pay,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.pay_setting,
                                      "open_double_pay",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advSet.pay_setting.open_double_pay",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-divider"),
              ]
            : _vm._e(),
          _c("h3", [_vm._v("SAAS用户")]),
          _vm.advSet && _vm.advSet.saas_setting
            ? [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              prop: "saas_setting.is_card_to_saas",
                              "label-width": "210px",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "开启后，当用户登陆卡用户时，会同步创建一个saas用户，方便用户参与saas活动。",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 有卡用户创建SAAS用户身份： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting.is_card_to_saas,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_card_to_saas",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advSet.saas_setting.is_card_to_saas",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              prop: "saas_setting.is_no_card_to_saas",
                              "label-width": "210px",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "开启后，当用户登陆卡用户时，会同步创建一个saas用户，方便用户参与saas活动。",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 无卡用户创建SAAS用户身份： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting.is_no_card_to_saas,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_no_card_to_saas",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n\t\t\t\t\t\t\t\tadvSet.saas_setting.is_no_card_to_saas\n\t\t\t\t\t\t\t",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              label: "SAAS用户强制绑定手机号：",
                              prop: "saas_setting.is_saas_bind_mobile",
                              "label-width": "190px",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting.is_saas_bind_mobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_saas_bind_mobile",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.is_saas_bind_mobile\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-divider"),
                _c("h3", [_vm._v("绑卡")]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              "label-width": "190px",
                              label: "专属链接仅绑本公司卡：",
                              prop: "saas_setting.is_exclusive_company_card",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "仅支持绑本公司的卡,错误代码BK002!",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 专属链接仅绑本公司卡： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .is_exclusive_company_card,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_exclusive_company_card",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.is_exclusive_company_card\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              "label-width": "220px",
                              label: "本公司卡能否在主商城绑定：",
                              prop: "saas_setting.is_card_can_bind_in_main_mall",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "此卡仅限在专属商城使用，错误代码BK001！",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 本公司卡能否在主商城绑定： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .is_card_can_bind_in_main_mall,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_card_can_bind_in_main_mall",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting\n                                                .is_card_can_bind_in_main_mall\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.advSet.saas_setting.is_card_can_bind_other_customer
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "radioStyle",
                                attrs: {
                                  "label-width": "230px",
                                  label: "本公司用户允许绑其他公司卡：",
                                  prop: "saas_setting.is_card_can_bind_other_customer",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "允许时，本公司用户可以绑定其他公司的卡；不允许时，本公司用户绑定其他公司卡时，系统自动创建新账号绑卡。",
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "el-icon-warning-outline img-icon",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" 本公司用户允许绑其他公司卡： "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.advSet.saas_setting
                                          .is_card_can_bind_other_customer,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advSet.saas_setting,
                                          "is_card_can_bind_other_customer",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n                                            advSet.saas_setting\n                                                .is_card_can_bind_other_customer\n                                        ",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("允许"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("不允许"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("el-divider"),
                _c("h3", [_vm._v("登录")]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              label: "手机号白名单登录：",
                              prop: "saas_setting.is_whitelist_login",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "专属链接使用手机号登录时，仅限系统已录入的手机号，不在此范围内，会提示：此手机号不在企业授权范围内，错误代码：MB001",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 手机号白名单登录： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting.is_whitelist_login,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_whitelist_login",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.is_whitelist_login\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "是否h5登陆", prop: "is_h5_login" },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.advSet.saas_setting.is_h5_login,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_h5_login",
                                      $$v
                                    )
                                  },
                                  expression: "advSet.saas_setting.is_h5_login",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("支持"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("不支持"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              label: "专属链接可切换企业：",
                              prop: "saas_setting.is_can_switch_account",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .is_can_switch_account,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_can_switch_account",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.is_can_switch_account\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              label: "本企业用户允许切换企业：",
                              prop: "saas_setting.is_can_switch_current_account",
                              "label-width": "200px",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "设置为开启时，在【首页】及【我的-个人信息】 展示【切换企业】的按钮；设置为关闭时，不展示【切换企业】按钮。",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 本企业用户允许切换企业： "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .is_can_switch_current_account,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_can_switch_current_account",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advSet.saas_setting.is_can_switch_current_account",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-divider"),
                _c("h3", [_vm._v("0元卡")]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "190px",
                              label: "有效期内0元礼包卡是否展示",
                              prop: "display_unlimited_card",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .display_unlimited_card,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "display_unlimited_card",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.display_unlimited_card\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("跟随渠道配置"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("展示"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("不展示"),
                                ]),
                              ],
                              1
                            ),
                            _c("div", { staticStyle: { color: "#909399" } }, [
                              _vm._v(
                                " 该配置控制商城首页礼包卡组件和卡包是否显示有效期内0元礼包卡 "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "radioStyle",
                            attrs: {
                              "label-width": "260px",
                              label: "卡规则有效卡是否包含未过期的0元卡：",
                              prop: "saas_setting.is_include_zero_value_card",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .is_include_zero_value_card,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "is_include_zero_value_card",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting\n                                                .is_include_zero_value_card\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("默认跟随渠道配置"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("不包含"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("包含"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-divider"),
                _c("h3", [_vm._v("京东")]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "saas_setting.goods_list_source_logo",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "默认配置表示使用菜单配置，显示则菜单配置不生效，商品列表显示京东标识；隐藏则菜单配置不生效，商品列表不显示京东标识",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 商城商品列表京东标识 "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .goods_list_source_logo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "goods_list_source_logo",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.goods_list_source_logo\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("默认配置"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("显示"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("隐藏"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "saas_setting.goods_other_source_logo",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "其他页面包括商品详情、购物车、订单确认页。默认配置表示使用菜单配置，显示则菜单配置不生效，商品列表显示京东标识；隐藏则菜单配置不生效，商品列表不显示京东标识",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 商城其他页面京东标识 "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .goods_other_source_logo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "goods_other_source_logo",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.goods_other_source_logo\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("默认配置"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("显示"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("隐藏"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "saas_setting.jd_comment_component",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "【默认配置】表示使用菜单配置；【显示】表示菜单配置不生效，客户配置生效，商品详情显示京东评论；【隐藏】表示菜单配置不生效，客户配置生效，商品详情不显示京东评论",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "el-icon-warning-outline img-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" 商品详情京东评论 "),
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value:
                                    _vm.advSet.saas_setting
                                      .jd_comment_component,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.advSet.saas_setting,
                                      "jd_comment_component",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                            advSet.saas_setting.jd_comment_component\n                                        ",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("默认配置"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("显示"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("隐藏"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }